module.exports = __webpack_public_path__ + "img/10.b3868b59.png";